<template>
  <div>
    <core-filter />

    <core-toolbar />

    <core-drawer v-if="userRole !== 9" />

    <core-view />

    <core-overlay />
  </div>
</template>

<script>
import Filter from "../../components/core/Filter";
import Toolbar from "../../components/core/Toolbar";
import Drawer from "../../components/core/Drawer";
import View from "../../components/core/View";
import { checkNotificationPermission } from "@/components/Utils/SIPHelpers";
import Overlay from "@/components/Utils/Overlay.vue";

export default {
  name: "App",

  components: {
    "core-filter": Filter,
    "core-toolbar": Toolbar,
    "core-drawer": Drawer,
    "core-view": View,
    "core-overlay": Overlay,
  },

  data: () => ({
    browserNotif: null,
  }),
  computed: {
    dispatchChatWatcher() {
      return this.clientId && [3, 1].includes(this.userRole);
    },
    clientInfo() {
      return this.$store.getters["passport/CURRENT_USER"];
    },
    clientId() {
      return this.$store.getters["passport/GET_CLIENT_ID"];
    },
    userRole() {
      return this.$store.getters["passport/GET_ROLE"];
    },
  },
  /**
   * This was used with the websocket method
   */
  // watch: {
  //   dispatchChatWatcher(val) {
  //     if (val) this.createChatWatcher();
  //   },
  // },
  created() {
    /**
     * This was used with the websocket method
     */
    // if (this.userRole < 3) this.createWatcher(this.clientId);
    // if (this.userRole === 3) {
    //   this.createCallbackWatcher();
    //   this.createTypificationWatcher();
    //   this.createMessageWatcher();
    // }
    checkNotificationPermission();
  },
  beforeDestroy() {
    /**
     * This was used with the websocket method
     */
    // if (this.userRole < 3) this.deleteWatcher(this.clientId);
    // if (this.userRole === 3) {
    //   this.deleteCallbackWatcher();
    //   this.deleteTypificationWatcher();
    //   this.deleteMessageWatcher();
    // }
    // this.removeChatWatcher();
  },
  methods: {
    // createWatcher(val, oldVal = null) {
    //   if (!val) return;
    //   if (Number(oldVal)) window.Echo.leaveChannel(`pauseAgent_${oldVal}`);
    //   window.Echo.channel(`pauseAgent_${val}`).listen("NewMessage", ({ message }) => {
    //     // console.log(message);
    //     const userName = message.user.name;
    //     const pauseName = message.pause.name;
    //     this.$snotify.warning(
    //       `El usuario ${userName} ha iniciado ${pauseName}`,
    //       "Pausa activada",
    //       { timeout: 15000 }
    //     );
    //   });
    // },
    // deleteWatcher(id) {
    //   window.Echo.leaveChannel(`pauseAgent_${id}`);
    // },
    /**
     * This was used with the websocket method
     */
    /*
    async createCallbackWatcher() {
      try {
        const { client_id, queues } = await getOwnQueues();
        queues.forEach((queue) => {
          window.Echo.channel(`callBack_${client_id}_${queue}`).listen(
            "NewMessage",
            ({ message }) => {
              // console.log(message);
              this.$snotify.warning(message.number_phone, "Devolucion", {
                timeout: 15000,
                titleMaxLength: 1000,
              });
            }
          );
        });
      } catch (error) {
        return;
      }
    },
    async deleteCallbackWatcher() {
      try {
        const { client_id, queues } = await getOwnQueues();
        queues.forEach((queue) => {
          window.Echo.leaveChannel(`callBack_${client_id}_${queue}`);
        });
      } catch (err) {
        return;
      }
    },
    async createTypificationWatcher() {
      try {
        const { client_id, queues, extension } = await getOwnQueues();
        queues.forEach((queue) => {
          // console.log(`created tiping_${client_id}_${queue}_${this.clientInfo.name}`);
          window.Echo.channel(
            `tiping_${client_id}_${queue}_${extension}`
          ).listen("NewMessage", ({ message, ...rest }) => {
            // console.log("message", message);
            // console.log("rest", rest);
            const name = message.contact?.name.length
              ? `${message.contact.name} ${message.contact.lastNAme || ""}`
              : message.replaceAll('"', "");
            this.$snotify.warning(
              `Cola: ${queue} ${
                message.call_number ? `Numero:${message.call_number}` : ""
              }`,
              `${name}`,
              { timeout: 15000, titleMaxLength: 1000 }
            );
          });
        });
      } catch (err) {
        return;
      }
    },
    async deleteTypificationWatcher() {
      try {
        const { client_id, queues } = await getOwnQueues();
        queues.forEach((queue) => {
          window.Echo.leaveChannel(
            `tiping_${client_id}_${queue}_${this.clientInfo.name}`
          );
        });
      } catch (error) {
        return;
      }
    },

    async createMessageWatcher() {
      try {
        const { client_id, extension } =
          this.$store.getters["passport/CURRENT_USER"];

        window.Echo.channel(`private_${client_id}_${extension}`).listen(
          "NewMessage",
          ({ message, ...rest }) => {
            // console.log("message", message);
            // console.log("rest", rest);
            // console.log(message);
            this.$snotify.warning(message, "Mensaje", {
              timeout: 15000,
              titleMaxLength: 1000,
            });
          }
        );
      } catch (error) {
        return;
      }
    },

    async deleteMessageWatcher() {
      try {
        const { client_id, extension } =
          this.$store.getters["passport/CURRENT_USER"];
        window.Echo.leaveChannel(`private_${client_id}_${extension}`);
      } catch (error) {
        return;
      }
    },

    async createChatWatcher() {
      window.Echo.channel(`chat_${this.clientId}`).listen(
        "NewMessage",
        async (res) => {
          console.log(res);
          this.$store.dispatch("chats/SET_NEW_MESSAGE", res);

          if (
            this.userRole !== 3 ||
            ![this.clientInfo.id, null].includes(res.message.ticket.userId)
          )
            return;

          const notifMessage =
            res.message.ticket.userId === null
              ? "Nuevo chat en cola"
              : "Nuevo mensaje de chat";

          if (await checkNotificationPermission()) {
            this.browserNotif?.cancel?.();

            this.browserNotif = new Notification("Chats", {
              body: notifMessage,
            });
            this.browserNotif.onclose = function () {
              this.browserNotif = null;
            };
          }

          this.$snotify.warning(notifMessage, "Chat");
        }
      );
    },

    removeChatWatcher() {
      window.Echo.leaveChannel(`chat_${this.clientId}`);
    },
   */
  },
};

/**
 * {
    "channel": "chat_25",
    "message": {
        "ticket": {
            "status": "pending",
            "contactId": 10768,
            "whatsappId": 1,
            "lastMessage": "test",
            "unreadMessages": 1,
            "updated_at": "2023-04-17 15:23:44",
            "created_at": "2023-04-17 15:23:44",
            "id": 59
        },
        "message": {
            "id": "3EB0DBDCDDDF9639D941B4",
            "body": "test",
            "ack": 1,
            "mediaType": "chat",
            "fromMe": false,
            "read": true,
            "isDeleted": false,
            "contactNumber": "584128270494",
            "quotedMsgId": null,
            "msgTimeStamp": 1681763023,
            "from": "584128270494@c.us",
            "to": "573015553222@c.us",
            "mediaUrl": null,
            "observaciones": null,
            "userId": null,
            "ticketId": 59,
            "updated_at": "2023-04-17 15:23:44",
            "created_at": "2023-04-17 15:23:44",
            "order": 2673
        },
        "last_message": "test"
    }
}
 */
</script>

<style></style>
